import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { UrlPrefix } from "../../shared-module/common/constants/url-prefix.constants";
@Injectable({
    providedIn: 'root'
  })
export class MenuService {
    constructor(private http: HttpClient) { }

    public newChangeSet = new BehaviorSubject<boolean>(null);
    public refreshMenuNodes = new BehaviorSubject<boolean>(null);

    public getHiddenMenuItemKeys(): Observable<Array<string>> {
        return this.http.get<Array<string>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/menu/items/hidden`);
    }
}
